
import CommomProxy from '@/components/proxy/CommomProxy'

let child_routes = [{
        path: 'findHealthcare',
        name: 'findHealthcare',
        component: resolve => {
            require(['@/views/patient/findHealthcare/index.vue'], resolve);
        },
        meta: {
            title: '找医护'
        }
    },
    {
        path: 'homecareStudio/index',
        name: 'homecareStudio',
        component: resolve => {
            require(['@/views/patient/homecareStudio/index.vue'], resolve);
        },
        meta: {
            title: '医生工作室'
        }
    },
    {
        path: 'homecareStudio/myteam',
        name: 'myteam',
        component: resolve => {
            require(['@/views/patient/homecareStudio/myteam.vue'], resolve);
        },
        meta: {
            title: '医生团队'
        }
    },
    {
        path: 'homecareStudio/homecare',
        name: 'homecare',
        component: resolve => {
            require(['@/views/patient/homecareStudio/homecare.vue'], resolve);
        },
        meta: {
            title: '医护上门'
        }
    },
      {
          path: 'homecareStudio/articleDetail',
          name: 'articleDetail',
          component: resolve => {
              require(['@/views/patient/homecareStudio/articleDetail.vue'], resolve);
          },
          meta: {
              title: '文章详情'
          }
      },
    {
        path: 'findHealthcare/doctorList',
        name: 'doctorList',
        component: resolve => {
            require(['@/views/patient/findHealthcare/doctor-or-nurses.vue'], resolve);
        },
        meta: {
            title: ''
        }
    },
    {
        path: 'search',
        name: 'patientSearch',
        component: resolve => {
            require(['@/views/patient/findHealthcare/search.vue'], resolve);
        },
        meta: {
            title: ''
        }
    }
]

let route = [{
    path: '/patient',
    component: CommomProxy,
    children: child_routes
}]

export default route



// WEBPACK FOOTER //
// ./src/router/patient.js